module.exports = __webpack_public_path__ + "img/bocatas.7f0dc546.jpeg";